import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import UnwantedEnquiriesLayer from "../components/UnwantedEnquiriesLayer";

const UnwantedEnquiriesPage = () => {
    return (
        <MasterLayout>
            <UnwantedEnquiriesLayer />
        </MasterLayout>
    );
};

export default UnwantedEnquiriesPage;
